{
  "COMPOSE_REDIRECT": {
    "OPENING": "Отваряне на нов разговор с {email}…",
    "NO_EMAIL": "Не е посочен имейл адрес. Използвайте ?email=name@example.com",
    "CONTACT_ERROR": "Контактът за {email} не можа да бъде намерен."
  },
  "CONVERSATION": {
    "IMAGE_RESIZE": {
      "SMALL": "Малък",
      "MEDIUM": "Среден",
      "LARGE": "Голям",
      "ORIGINAL": "Оригинален"
    },
    "SHOW_HIDDEN_MESSAGES": "Покажи скритите съобщения",
    "SELECT_A_CONVERSATION": "Please select a conversation from left pane",
    "CSAT_REPLY_MESSAGE": "Please rate the conversation",
    "404": "Sorry, we cannot find the conversation. Please try again",
    "SWITCH_VIEW_LAYOUT": "Switch the layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Messages",
    "UNVERIFIED_SESSION": "The identity of this user is not verified",
    "NO_MESSAGE_1": "Uh oh! Looks like there are no messages from customers in your inbox.",
    "NO_MESSAGE_2": " to send a message to your page!",
    "NO_INBOX_1": "Hola! Looks like you haven't added any inboxes yet.",
    "NO_INBOX_2": " to get started",
    "NO_INBOX_AGENT": "Uh Oh! Looks like you are not part of any inbox. Please contact your administrator",
    "SEARCH_MESSAGES": "Search for messages in conversations",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Превод",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Search messages",
      "RESULT_TITLE": "Search Results",
      "LOADING_MESSAGE": "Crunching data...",
      "PLACEHOLDER": "Type any text to search messages",
      "NO_MATCHING_RESULTS": "No results found."
    },
    "TRANSCRIPT": {
      "SHOW": "Покажи пълния транскрипт",
      "HIDE": "Скрий пълния транскрипт",
      "DOWNLOAD": "Изтегли транскрипта",
      "COPY": "Копирай транскрипта"
    },
    "INVISIBLE_TO_CUSTOMER": "Невидимо за клиента",
    "SENT_VIA_EMAIL": "Изпратено на контакта и по имейл ({time})",
    "UNREAD_MESSAGES": "Unread Messages",
    "UNREAD_MESSAGE": "Unread Message",
    "CLICK_HERE": "Click here",
    "LOADING_INBOXES": "Loading inboxes",
    "LOADING_CONVERSATIONS": "Loading Conversations",
    "CANNOT_REPLY": "You cannot reply due to",
    "24_HOURS_WINDOW": "24 hour message window restriction",
    "API_HOURS_WINDOW": "Можете да отговаряте на този разговор само в рамките на {hours} часа",
    "FACEBOOK_CANNOT_REPLY": "Ако трябва да продължите този разговор, ",
    "NOT_ASSIGNED_TO_YOU": "This conversation is not assigned to you. Would you like to assign this conversation to yourself?",
    "ASSIGN_TO_ME": "Assign to me",
    "PENDING_WITH_BOT_BANNER": "Този разговор се обработва от AI бот. Ако искате да отговорите, първо отворете разговора.",
    "INBOX_DELETE_REQUESTED_BANNER": "Тази входяща кутия е маркирана за изтриване, затова отговорът на клиента никога няма да пристигне. Преместете разговора в друга входяща кутия, за да отговорите.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Този контакт има друг отворен разговор #{id}",
      "MULTIPLE": "Този контакт има други отворени разговори ({count})",
      "OPEN": "Отвори",
      "SHOW": "Покажи"
    },
    "TWILIO_WHATSAPP_CAN_REPLY": "You can only reply to this conversation using a template message due to",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 hour message window restriction",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Този Instagram акаунт беше мигриран в новата Instagram канална кутия. Всички нови съобщения ще се появяват там. Повече няма да можете да изпращате съобщения от този разговор.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Не може да се изпрати съобщение, защото клиентът не е онлайн и имейл приемственост не е налична.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Клиентът не е онлайн. Може да не получава съобщения, тъй като имейл приемственост не е налична.",
    "REPLYING_TO": "You are replying to:",
    "REMOVE_SELECTION": "Remove Selection",
    "DOWNLOAD": "Download",
    "OPEN_FILE": "Отвори",
    "DOWNLOAD_ATTACHMENTS": "Изтегли всички",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Изтегли всички прикачени файлове един по един",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Изтегли всички като ZIP",
    "ERROR_DOWNLOADING_FILE": "Грешка при изтегляне на файла",
    "UNKNOWN_FILE_TYPE": "Unknown File",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Преди изпращане извършете:",
      "EXECUTE": "Изпълни",
      "RETRY": "Опитай отново",
      "CONFIRM": "Да се изпълни ли сега?",
      "CONFIRM_YES": "Да, изпълни",
      "CONFIRM_NO": "Отказ",
      "RUNNING": "Изпълнява се…",
      "DONE": "Изпълнено",
      "CLAIM_DELAYED": "ще бъде подадена след доставката на поръчката",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Създадена е НОВА рекламация {reference}, {planned} е затворена — редактирайте текста на черновата",
        "NEW_CLAIM": "Създадена е НОВА рекламация {reference} вместо актуализиране на {planned} — редактирайте текста на черновата",
        "OTHER_CLAIM": "Актуализирана е рекламация {reference} вместо {planned} — редактирайте текста на черновата",
        "EXISTING_CLAIM": "Не е създадена нова рекламация, актуализирана е съществуващата {reference} — редактирайте текста на черновата",
        "OTHER": "Протече по различен начин, отколкото черновата предполагаше — редактирайте текста на черновата"
      },
      "FAILED": "Неуспешно",
      "UNREACHABLE": "Ботът не е достъпен",
      "REQUEST_FAILED": "Действието не можа да бъде стартирано, моля, опитайте отново.",
      "ACTIONS": {
        "CANCEL_ORDER": "Отменете поръчката",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Променете плащането на наложен платеж",
        "CREATE_CLAIM": "Подайте рекламация",
        "CREATE_OR_UPDATE_CLAIM": "Подайте или актуализирайте рекламация",
        "EXTEND_ORDER_PICKUP_DATE": "Удължете срока за получаване"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Uploading attachments...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Message deleted successfully",
    "FAIL_DELETE_MESSSAGE": "Couldn't delete message! Try again",
    "NO_RESPONSE": "No response",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Помолете клиента да сподели телефонния си номер за WhatsApp",
      "PENDING_ACTION": "Чакаща заявка за информация за контакт",
      "STATES": {
        "PENDING": "Изчаква се информация за контакт",
        "SHARED": "Телефонният номер е споделен",
        "IDENTITY_CONFLICT": "Телефонният номер се нуждае от проверка"
      }
    },
    "RESPONSE": "Response",
    "RATING_TITLE": "Rating",
    "FEEDBACK_TITLE": "Feedback",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels"
    },
    "HEADER": {
      "MORE": "Още действия",
      "RESOLVE_ACTION": "Resolve",
      "REOPEN_ACTION": "Reopen",
      "OPEN_ACTION": "Отворен",
      "OPEN": "More",
      "CLOSE": "Close",
      "DETAILS": "details",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Snoozed until tomorrow",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozed until next week",
      "SNOOZED_UNTIL_NEXT_REPLY": "Snoozed until next reply",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Mark as pending",
      "SNOOZE_UNTIL": "Snooze",
      "RESOLVE_WITHOUT_CSAT": "Разрешаване без CSAT",
      "SNOOZE": {
        "TITLE": "Snooze until",
        "NEXT_REPLY": "Next reply",
        "TOMORROW": "Tomorrow",
        "NEXT_WEEK": "Next week"
      }
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Snooze until",
      "APPLY": "Snooze",
      "CANCEL": "Отмени"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Нито един",
        "URGENT": "Спешен",
        "HIGH": "Висок",
        "MEDIUM": "Среден",
        "LOW": "Нисък"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Нито един",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Няма намерени резултати",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "SLA": {
      "BREACHED": "нарушен"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Отваряне в нов раздел",
      "COPY_LINK": "Копиране на връзката към разговора",
      "COPY_LINK_SUCCESS": "Връзката към разговора е копирана в клипборда",
      "PENDING": "Mark as pending",
      "RESOLVED": "Mark as resolved",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Reopen conversation",
      "SNOOZE": {
        "TITLE": "Snooze",
        "NEXT_REPLY": "Until next reply",
        "TOMORROW": "Until tomorrow",
        "NEXT_WEEK": "Until next week"
      },
      "ASSIGN_AGENT": "Assign agent",
      "ASSIGN_LABEL": "Assign label",
      "AGENTS_LOADING": "Loading agents...",
      "ASSIGN_TEAM": "Assign team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assigned to \"{agentName}\"",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Message signature",
      "ENABLE_SIGN_TOOLTIP": "Enable signature",
      "DISABLE_SIGN_TOOLTIP": "Disable signature",
      "INSERT_SIGNATURE": "Вмъкни подпис в редактора",
      "SIGNATURE_PREVIEW_IMAGE": "(изображение на подпис)",
      "MSG_INPUT": "Shift + enter for new line. Start with '/' to select a Canned Response.",
      "PRIVATE_MSG_INPUT": "Shift + enter for new line. This will be visible only to Agents",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Message signature is not configured, please configure it in profile settings.",
      "CLICK_HERE": "Click here to update",
      "WHATSAPP_TEMPLATES": "Whatsapp Templates",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24-часовият прозорец на WhatsApp изтече. Отговорете с шаблонно съобщение."
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Изглежда, че отговорът ви е на {draftLanguage}, но този разговор е на {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Преведи",
      "REPLY": "Reply",
      "PRIVATE_NOTE": "Private Note",
      "SEND": "Send",
      "SEND_EMAIL": "Изпрати имейл",
      "SEND_SMS": "Изпрати SMS",
      "NO_SMS_INBOX": "Добавете SMS кутия, за да изпращате SMS отговори.",
      "SEND_CHAT": "Изпрати чат",
      "CREATE": "Add Note",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "REPLY_TO_THIS": "Отговори на това",
      "TIP_EXPAND_ICON": "Уголеми редактора",
      "TIP_COLLAPSE_ICON": "Смали редактора",
      "TIP_FORMAT_ICON": "Show rich text editor",
      "HEADING_LEVEL": {
        "LABEL": "Стил на текста",
        "NORMAL": "Обикновен текст",
        "H1": "Заглавие 1",
        "H2": "Заглавие 2",
        "H3": "Заглавие 3"
      },
      "EDITOR": {
        "BOLD": "Получер",
        "ITALIC": "Курсив",
        "UNDERLINE": "Подчертан",
        "TEXT_COLOR": "Цвят на текста",
        "BG_COLOR_LABEL": "Цвят на фона",
        "FONT_SIZE_LABEL": "Размер на шрифта",
        "FONT_SIZE": {
          "XS": "Малък",
          "SM": "Среден малък",
          "MD": "По подразбиране",
          "LG": "Голям",
          "XL": "Много голям",
          "XXL": "Огромен"
        },
        "CODE": "Код",
        "LINK": "Добавяне или премахване на връзка",
        "CREATE_LINK": "Създаване на връзка",
        "SAVE_LINK": "Запазване",
        "CANCEL": "Отказ",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Отмяна",
        "REDO": "Повтаряне",
        "BULLET_LIST": "Списък с водещи символи",
        "ORDERED_LIST": "Номериран списък",
        "BLOCKQUOTE": "Цитат",
        "H1": "Заглавие 1",
        "H2": "Заглавие 2",
        "H3": "Заглавие 3",
        "IMAGE_UPLOAD": "Качване на изображение",
        "CLEAR_FORMATTING": "Изчистване на форматирането",
        "COLOR": {
          "RED": "Червено",
          "YELLOW": "Жълто",
          "BLUE": "Синьо",
          "ROSE_RED": "Розово-червено",
          "DEEP_CYAN": "Тъмен циан",
          "ORANGE": "Оранжево",
          "PISTACHIO": "Фъстъчено зелено",
          "PURPLE": "Лилаво",
          "FUCHSIA": "Фуксия",
          "SILVER": "Сребърно",
          "NAVY": "Тъмносиньо",
          "OLD_PINK": "Старо розово",
          "AQUA": "Аква",
          "BROWN": "Кафяво",
          "OLIVE": "Маслинено",
          "GOLD": "Златно",
          "BEIGE": "Бежово",
          "WINE": "Винено",
          "FOREST": "Горско зелено",
          "GREEN": "Зелено",
          "BLUE_GREY": "Синьо-сиво",
          "RUBY_RED": "Рубинено червено",
          "CHESTNUT_BROWN": "Кестеняво кафяво",
          "ASH_GREY": "Пепеляво сиво"
        },
        "BG_COLOR": {
          "RED": "Червено",
          "YELLOW": "Жълто",
          "BLUE": "Синьо",
          "ROSE_RED": "Розово-червено",
          "DEEP_CYAN": "Тъмен циан",
          "ORANGE": "Оранжево",
          "PISTACHIO": "Фъстъчено зелено",
          "PURPLE": "Лилаво",
          "FUCHSIA": "Фуксия",
          "SILVER": "Сребърно",
          "NAVY": "Тъмносиньо",
          "OLD_PINK": "Старо розово",
          "AQUA": "Аква",
          "BROWN": "Кафяво",
          "OLIVE": "Маслинено",
          "GOLD": "Златно",
          "BEIGE": "Бежово",
          "WINE": "Винено",
          "FOREST": "Горско зелено",
          "GREEN": "Зелено",
          "BLUE_GREY": "Синьо-сиво",
          "RUBY_RED": "Рубинено червено",
          "CHESTNUT_BROWN": "Кестеняво кафяво",
          "ASH_GREY": "Пепеляво сиво"
        }
      },
      "TIP_EMOJI_ICON": "Show emoji selector",
      "TIP_ATTACH_ICON": "Attach files",
      "TIP_AUDIORECORDER_ICON": "Record audio",
      "TIP_AUDIORECORDER_PERMISSION": "Allow access to audio",
      "TIP_AUDIORECORDER_ERROR": "Could not open the audio",
      "DRAG_DROP": "Drag and drop here to attach",
      "START_AUDIO_RECORDING": "Start audio recording",
      "STOP_AUDIO_RECORDING": "Stop audio recording",
      "EMAIL_HEAD": {
        "EDIT": "Редактирай",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Скрий",
        "INCLUDE_ORIGINAL_MESSAGE": "Включи оригиналното съобщение",
        "TO": "TO",
        "ADD_BCC": "Add bcc",
        "EDIT_HEADERS": "Редактирай",
        "HIDE_HEADER_EDITS": "Скрий редакциите",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "SUBJECT": {
          "LABEL": "ТЕМА",
          "PLACEHOLDER": "Тема на имейла",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Send",
          "CANCEL": "Отмени"
        }
      },
      "COPILOT": {
        "Q": "Попитай робота за помощ"
      },
      "": ""
    },
    "VISIBLE_TO_AGENTS": "Private Note: Only visible to you and your team",
    "CHANGE_STATUS": "Conversation status changed",
    "CHANGE_STATUS_FAILED": "Conversation status change failed",
    "CHANGE_AGENT": "Conversation Assignee changed",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "Conversation team changed",
    "IMAGE_UPLOAD_ERROR": "Не може да се качи изображение, моля опитайте отново",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "DRAFT": {
      "FILE_TOO_LARGE": "Файлът {fileName} ({fileSize}) е твърде голям за съхранение в чернова и ще бъде пропуснат",
      "ATTACHMENT_SERIALIZATION_FAILED": "Неуспешно сериализиране на прикачен файл за съхранение в чернова",
      "STORAGE_QUOTA_EXCEEDED": "Квотата за съхранение е превишена. Черновата е запазена без прикачени файлове",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Неуспешно запазване на черновата дори без прикачени файлове",
      "SAVE_FAILED": "Неуспешно запазване на чернова на разговор"
    },
    "MESSAGE_ERROR": "Unable to send this message, please try again later",
    "SENT_BY": "Sent by:",
    "BOT": "Бот",
    "SEND_FAILED": "Couldn't send message! Try again",
    "TRY_AGAIN": "retry",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Select Agent",
      "REMOVE": "Remove",
      "ASSIGN": "Assign"
    },
    "CONTEXT_MENU": {
      "COPY": "Copy",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Изтрий",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "FORWARD": "Препрати",
      "FORWARD_ERROR": "Неуспешна подготовка на препратеното съобщение",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Изтрий",
        "CANCEL": "Отмени"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Контакт",
      "COPILOT": "Copilot"
    },
    "COMMENT_TREE": {
      "TITLE": "Тема на коментар",
      "EMPTY": "Няма коментари за показване",
      "VIEW_TREE": "Покажи темата на коментара"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Conversation was marked resolved by {userName}",
          "CONTACT_RESOLVED": "Conversation was resolved by {contactName}",
          "OPEN": "Conversation was reopened by {userName}",
          "PENDING": "Conversation was marked as pending by {userName}",
          "SNOOZED": "Conversation was snoozed by {userName}",
          "AUTO_RESOLVED": "Conversation was marked resolved by system due to {duration} days of inactivity",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Системата реши разговора, защото тикетът беше затворен в Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} self-assigned this conversation",
          "ASSIGNED": "Assigned to {assigneeName} by {userName}",
          "REMOVED": "Conversation unassigned by {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Assigned to {teamName} by {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Assigned to {assigneeName} via {teamName} by {userName}",
          "REMOVED": "Unassigned from {teamName} by {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} added {labels}",
          "REMOVED": "{userName} removed {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} has muted the conversation",
        "UNMUTED": "{userName} has unmuted the conversation",
        "CONTACT_BLOCKED": "{userName} блокира контакта",
        "CONTACT_UNBLOCKED": "{userName} отблокира контакта",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Преместен, защото поръчките на контакта са само от магазина {storeName} (последна поръчка {orderId}), чийто робот отговаря в тази входяща кутия.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Автоматизацията беше пропусната, защото контактът е блокиран",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Автоматизацията \"{ruleName}\" не можа да премести този разговор от кутия {sourceInboxName} в кутия {targetInboxName}, защото кутиите не са съвместими.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Автоматизацията \"{ruleName}\" не можа да премести този разговор от кутия {sourceInboxName} в кутия {targetInboxName}, защото контактът няма имейл адрес.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Автоматизацията \"{ruleName}\" не успя да изпрати съобщение: тази телефонна входяща кутия не може да изпраща SMS, защото акаунтът няма SMS входяща кутия. Правилото беше изключено и администраторите получиха имейл.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Автоматизацията \"{ruleName}\" не успя да изпрати съобщение: от тази входяща кутия не могат да се изпращат прикачени файлове чрез SMS. Правилото беше изключено и администраторите получиха имейл.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Макросът \"{macroName}\" не изпрати съобщението си: тази телефонна входяща кутия не може да изпраща SMS, защото акаунтът няма SMS входяща кутия.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Макросът \"{macroName}\" не изпрати съобщението си: от тази входяща кутия не могат да се изпращат прикачени файлове чрез SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Макросът \"{macroName}\" не изпрати съобщението си: този разговор се обработва от бот. Първо отворете разговора.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Макросът \"{macroName}\" не изпрати съобщението си: тази входяща кутия е маркирана за изтриване. Първо преместете разговора в друга входяща кутия.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Автоматизацията \"{ruleName}\" изпрати имейл до {contactEmail} в нов разговор [#{conversationId}]({conversationPath}) в кутия {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Автоматизацията \"{ruleName}\" започна този разговор заради разговор [#{conversationId}]({conversationPath}) в кутия {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Автоматизацията \"{ruleName}\" не можа да изпрати съобщението в нов разговор в кутия {inboxName}, защото контактът няма имейл адрес.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Автоматизацията \"{ruleName}\" изпрати SMS до {contactPhone} в нов разговор [#{conversationId}]({conversationPath}) в кутия {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Автоматизацията \"{ruleName}\" не можа да изпрати SMS в нов разговор в кутия {inboxName}, защото контактът няма телефонен номер.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Агент",
            "CUSTOMER": "Клиент"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "отговорено другаде, звънял {duration}",
            "NO_ANSWER": "без отговор, звънял {duration}",
            "REJECTED": "отхвърлено след звънене {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Решено автоматично след неуспешни обратни обаждания: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Записът на разговора е изтрит от {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Send conversation transcript",
    "DESC": "Send a copy of the conversation transcript to the specified email address",
    "SUBMIT": "Изпращане",
    "CANCEL": "Отмени",
    "SEND_EMAIL_SUCCESS": "The chat transcript was sent successfully",
    "SEND_EMAIL_ERROR": "There was an error, please try again",
    "FORM": {
      "SEND_TO_CONTACT": "Send the transcript to the customer",
      "SEND_TO_AGENT": "Send the transcript to the assigned agent",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Send the transcript to another email address",
      "EMAIL": {
        "PLACEHOLDER": "Enter an email address",
        "ERROR": "Please enter a valid email address"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hey 👋, Welcome to {installationName}!",
    "DESCRIPTION": "Thanks for signing up. We want you to get the most out of {installationName}. Here are a few things you can do in {installationName} to make the experience delightful.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Read our latest updates",
    "ALL_CONVERSATION": {
      "TITLE": "All your conversations in one place",
      "DESCRIPTION": "View all the conversations from your customers in one single dashboard. You can filter the conversations by the incoming channel, label and status.",
      "NEW_LINK": "Click here to create an inbox"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invite your team members",
      "DESCRIPTION": "Since you are getting ready to talk to your customer, bring in your teammates to assist you. You can invite your teammates by adding their email addresses to the agent list.",
      "NEW_LINK": "Click here to invite a team member"
    },
    "LABELS": {
      "TITLE": "Organize conversations with labels",
      "DESCRIPTION": "Labels provide an easier way to categorize your conversation. Create some labels like #support-enquiry, #billing-question etc., so that you can use them in a conversation later.",
      "NEW_LINK": "Click here to create tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Assigned Agent",
    "SELF_ASSIGN": "Assign to me",
    "TEAM_LABEL": "Assigned Team",
    "SELECT": {
      "PLACEHOLDER": "None"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "ORDER_HISTORY": "История на поръчките",
      "CONTACT_DETAILS": "Contact Details",
      "CONVERSATION_ACTIONS": "Conversation Actions",
      "CONVERSATION_LABELS": "Етикети на разговора",
      "CONVERSATION_INFO": "Conversation Information",
      "CONTACT_ATTRIBUTES": "Contact Attributes",
      "PREVIOUS_CONVERSATION": "Предишни разговори",
      "MACROS": "Macros",
      "RETINO_TICKETS": "Retino тикети",
      "SHOPIFY_ORDERS": "Shopify Orders"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Предстоящ",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Зареди още",
    "NO_RECORDS_FOUND": "Не са намерени тикети",
    "LOAD_ERROR": "Не можем да заредим тикети от {hookName}. Моля, опитайте по-късно.",
    "NOT_SEARCHABLE": "Имейлът на контакта не е зададен.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Зареждане...",
    "NO_ORDERS": "Няма намерени поръчки",
    "NOT_AVAILABLE": "Данните за клиента не са налични",
    "EXPAND": "Отвори профила на клиента",
    "MORE_ITEMS": "+ {count} артикула",
    "EXPEDITION_STATUS": "Статус на експедицията",
    "OPEN_DETAIL": "отвори детайла",
    "COPY_ORDER_ID": "Номер на поръчката",
    "EXTERNAL_ID": "Външен идентификатор",
    "PAYMENT_TYPE": "Начин на плащане",
    "PAYMENT_DATE": "Дата на плащане",
    "DELIVERY_PROVIDER": "Доставчик",
    "EXPECTED_DATE_OF_DELIVERY": "Очаквана доставка",
    "DATE_OF_DELIVERY": "Доставено на",
    "EXPEDITION_DATE": "Дата на експедиция",
    "INTERNAL_NOTE": "Бележка на магазина",
    "PACKAGE_NUMBER": "Пратка"
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Create attribute",
    "NO_RECORDS_FOUND": "Няма намерени атрибути",
    "UPDATE": {
      "SUCCESS": "Атрибута е обновен успешно",
      "ERROR": "Атрибута не бе обновен. Моля, опитайте отново по-късно"
    },
    "ADD": {
      "TITLE": "Добавяне",
      "SUCCESS": "Атрибута е добавен успешно",
      "ERROR": "Атрибута не бе добавен. Моля, опитайте отново по-късно"
    },
    "DELETE": {
      "SUCCESS": "Успешно изтриване на атрибута",
      "ERROR": "Атрибута не бе изтрита. Моля, опитайте отново по-късно"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Добавяне на атрибут",
      "PLACEHOLDER": "Търсене на атрибути",
      "NO_RESULT": "Няма намерени атрибути"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "From",
    "TO": "До",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Subject"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Няма намерени резултати",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Някой пише"
  },
  "READING": {
    "ONE": "{user} чете този тикет",
    "TWO": "{user} и {secondUser} четат този тикет",
    "MULTIPLE": "{user} и още {count} четат този тикет"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Преместване на разговора",
    "DESCRIPTION": "Преместете този разговор в друга имейл кутия.",
    "SOURCE": {
      "TITLE": "Разговор",
      "ID_LABEL": "ID на разговора"
    },
    "TARGET": {
      "TITLE": "Целева кутия",
      "PLACEHOLDER": "Изберете имейл кутия",
      "NO_RESULTS": "Няма други налични имейл кутии",
      "ERROR": "Моля, изберете целева кутия"
    },
    "SUBMIT": "Премести разговора",
    "CANCEL": "Отказ",
    "SUCCESS_MESSAGE": "Разговорът е преместен успешно",
    "ERROR_MESSAGE": "Не можахме да преместим разговора. Моля, опитайте отново."
  },
  "MERGE": {
    "TITLE": "Обединяване на разговори",
    "DESCRIPTION": "Обединете този разговор с друг разговор. Всички съобщения от този разговор ще бъдат преместени в целевия разговор, а този разговор ще бъде изтрит.",
    "SOURCE": {
      "TITLE": "Изходен разговор (ще бъде изтрит)",
      "ID_LABEL": "ID на разговора"
    },
    "TARGET": {
      "TITLE": "Целеви разговор",
      "PLACEHOLDER": "Въведете ID на разговор за търсене (напр. 123)",
      "HELP": "Въведете ID на разговора, в който да се обединят всички съобщения.",
      "ERROR": "Моля, изберете целеви разговор"
    },
    "WARNING": "Внимание: Това действие не може да бъде отменено. Всички съобщения ще бъдат преместени в целевия разговор, а този разговор ще бъде изтрит за постоянно.",
    "SUBMIT": "Обедини разговорите",
    "CANCEL": "Отказ",
    "SUCCESS_MESSAGE": "Разговорът е обединен успешно",
    "ERROR_MESSAGE": "Не можахме да обединим разговорите. Моля, проверете целевия разговор и опитайте отново.",
    "SEARCH": {
      "NO_RESULTS": "Не е намерен разговор с това ID",
      "ERROR_MESSAGE": "Не можахме да търсим разговори. Моля, опитайте отново."
    },
    "CONFIRM": {
      "TITLE": "Потвърждение на обединяването",
      "DESCRIPTION": "Сигурни ли сте, че искате да обедините този разговор? Това действие не може да бъде отменено.",
      "YES": "Да, обедини",
      "CANCEL": "Отказ"
    }
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
